import React from 'react'

const logout = () => {
  return (
    <div>
      
    </div>
  )
}

export default logout
